import React, {useState} from 'react';
import {ErrorMessageProps} from './ErrorsType';
import {MessageDialog} from '../MessageDialog/MessageDialog';
import {ApiError} from './ErrorBoundary';
import {HttpError} from '../../../../api/client';
import {useTranslation} from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';

function getMessageForInternalServerError(error : string | Error): {message: string, errorId: string}{
  let message = '';
  let errorId ='';
  const apiError = (error as HttpError).data as ApiError;
  try{
    message = apiError.message;
    errorId = apiError.referanseId;
    return {errorId: errorId, message: message};
  }catch(ex: any){
    return {errorId: ex.stack, message: ex.message};
  }
}
export const useStyleSpanUnderline = makeStyles(() =>
  ({
    underlineHover:{
      '&:hover': {
        'text-decoration': 'underline'
      }
    }

  })
);
export const InternalServerErrorMessage: React.FC<ErrorMessageProps> = ({error, open, onClose}) => {
  const {underlineHover} = useStyleSpanUnderline();
  const [showDetail, setShowDetail] = useState(false);
  const {t} = useTranslation();
  const {message, errorId} = getMessageForInternalServerError(error);
  return (
    <div>
      <MessageDialog title={'En feil har oppstått'} width={700} height={300}  open={open} onClose={onClose}>
        <div>
          <span onClick={() => setShowDetail(prev => !prev)} className={underlineHover}> Les mer.</span>
          <br/>
          {showDetail && (
            <>
              <span>{message}<br/></span>
              <br/>
              {
                errorId?.length &&
                (<span title={t('TraceId-Description')}>
                {t('ReferanseId')}: {errorId}
                  <br/>
                </span>)
              }
            </>)
          }
        </div>
      </MessageDialog>
    </div>
  );
};
